import './App.css';
import Resume from './components/resume';

function App() {
  return (
    <div className="App">
      <Resume />
    </div>
  );
}

export default App;
